import { useNavigate } from 'react-router-dom'
import { Lock, ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface AccessDeniedProps {
  message?: string
}

export function AccessDenied({
  message = 'You don\'t have permission to access this page.',
}: AccessDeniedProps) {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <div className="mb-6 rounded-2xl bg-destructive/10 p-5">
        <Lock className="h-10 w-10 text-destructive" />
      </div>
      <h1 className="mb-2 text-2xl font-bold tracking-tight">Access Denied</h1>
      <p className="mb-1 max-w-md text-sm text-muted-foreground">{message}</p>
      <p className="mb-8 max-w-md text-xs text-muted-foreground/70">
        Contact your administrator to request access.
      </p>
      <Button onClick={() => navigate('/dashboard')} className="gap-2">
        <ArrowLeft className="h-4 w-4" />
        Go to Dashboard
      </Button>
    </div>
  )
}
